
import { Separator } from "@/components/ui/separator";

export function InstallationInstructions() {
  return (
    <div className="space-y-4">
      <Separator />
      <h3 className="text-sm font-medium">2. Place the code before the closing {"</head>"} tag</h3>
      <p className="text-sm text-muted-foreground">
        Install the code on every page you want to track by adding it to your website's HTML, ideally right before the closing head tag.
      </p>
    </div>
  );
}
